
<template>

	<dialog-slot
			:title="item.title"
			@updateClose="onClose"
			@updateSave="onClose"
			width="1000px"
			is-cancel-hide
			apply-text="Close"
	>
		<div class="updateInfo">
			<div class="updateInfo_text">
				<span v-html="item.message"></span>
			</div>
		</div>

		<template v-slot:subTitleFooter>
			<div v-if="itemShow" class="checkbox">
				<v-checkbox
						dense
						v-model="isCheckbox"
						label="Don't show this again until a new notification is available"
				></v-checkbox>
			</div>
		</template>
	</dialog-slot>
</template>

<script>
import DialogSlot from "@/shared/DialogSlot/DialogSlot.vue";

export default {
	name: "NotificationDialog",
	components: {
		DialogSlot,
	},
	props: {
		item: Object,
		itemShow: Boolean
	},

	data: () => ({
		dialog: true,
		isCheckbox: false,
	}),
	methods: {
		onClose() {
			this.$emit('updateInfo', this.isCheckbox);
		}
	}
};
</script>

<style scoped lang="scss">
.updateInfoWrapper {
	.updateInfo {
		background: var(--card-bg);
		padding: 20px;

		.actionHeader {
			display: flex;
			justify-content: space-between;
			align-items: center;
			width: 100%;
			font-style: normal;
			font-weight: 500;
			font-size: 20px;
			line-height: 24px;
			letter-spacing: 0.25px;
			color: var(--card-color);
			margin-bottom: 20px;
		}
		&_text {
			margin-bottom: 20px;
			font-size: 14px;

			&-title {
				font-size: 18px;
				margin-bottom: 10px;
			}
		}
	}
}

[type="button"] {
	line-height: 0;
}
</style>
<style lang="scss">
.updateInfoWrapper {
	.updateInfo {
		&_text {
			* {
				background-color: transparent !important;
				background: transparent !important;
			}
		}
	}
}
</style>
